export const environment = {
  production: false,
  apiUrl: 'https://staging-api-bio-builder.gowwc.com/api',
  tokenAuthority: 'https://???/', //TODO: Needs updated
  cognito: {
    userPoolId: '', //TODO: Needs updated
    userPoolClientId: '', //TODO: Needs updated
    region: ''
  }
};
